const CUSTOMERS = ({ permissionIsEnabled }) => {
  return {
    key: 'customers',
    routeName: 'customers',
    label: 'sidemenu.customers',
    showSection: permissionIsEnabled('customer:search')
  }
}

export default CUSTOMERS
